import styles from './PaymentStatusFilter.module.scss';
import { PaymentStatus } from 'enums';
import { DropDownButton } from 'components/Buttons/DropDownButton/DropDownButton';

const options = ['All', PaymentStatus.Paid, PaymentStatus.Voided];

type Props = {
    paymentStatus: PaymentStatus | undefined,
    onStatusChange: (value: PaymentStatus) => void
};

const PaymentStatusFilter = ({ paymentStatus, onStatusChange }: Props) => (
    <DropDownButton 
        className={styles.control}
        items={options}
        onItemClick={(e) => onStatusChange(e.item === 'All' ? undefined : e.item)}
        text={`Status: ${paymentStatus ?? 'All'}`}
        fillMode={'solid'}
        rounded={'small'}
        tabIndex={0}
    />
);
export default PaymentStatusFilter;